import api from './api'

api.ready()
